import React from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon } from '@livable/saas-react-components';
import { CreateForm } from './createForm';
import { EditForm } from './editForm';
export const BillingAutomationSetup = observer(_ref => {
  var _billingTemplate$prov;
  let handleModalStates = _ref.handleModalStates,
    billingTemplate = _ref.billingTemplate,
    customTrigger = _ref.customTrigger,
    isEdit = _ref.isEdit;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    headerIcon: 'paper-dollar',
    title: t('add_new_property_flow.auto_billing_setup'),
    subTitle: (billingTemplate === null || billingTemplate === void 0 || (_billingTemplate$prov = billingTemplate.provider) === null || _billingTemplate$prov === void 0 ? void 0 : _billingTemplate$prov.utilityProviderName) || 'Provider name',
    trigger: customTrigger !== undefined ? customTrigger : /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      size: "small",
      'custom-attribute': '636-new-billing-module'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('add_new_property_flow.begin_activation')))
  }, isEdit ? /*#__PURE__*/React.createElement(EditForm, {
    handleModalStates: handleModalStates,
    billingTemplate: billingTemplate
  }) : /*#__PURE__*/React.createElement(CreateForm, {
    handleModalStates: handleModalStates,
    billingTemplate: billingTemplate
  }));
});